import React from 'react';
import LiroyText from './LiroyText';
import { defaultFont } from '../../../assets/fonts/defaultFont';

export default function TextMedium40({ children, ...props }) {
    return (
        <LiroyText
            {...props}
            size={40}
            fontWeight={defaultFont.medium}
        >
            {children}
        </LiroyText>
    );
}